import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import { ContactUsForm, contactusmail } from "@tecumseh/Services/contactUsService";

type SubmitContactFormParameter = {
    FirstName: string;
    LastName: string;
    Email: string;
    CountryId: string;
    CountryName: string;
    PhoneNumber: string;
    Company: string;
    Subject: string;
    OtherSubject: string;
    Message: string;
    subjectNumber: string;
    defaultEmailAddress: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactFormParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        FirstName: props.parameter.FirstName,
        LastName: props.parameter.LastName,
        Email: props.parameter.Email,
        CountryId: props.parameter.CountryId,
        CountryName: props.parameter.CountryName,
        PhoneNumber: props.parameter.PhoneNumber,
        Company: props.parameter.Company,
        Subject: props.parameter.Subject,
        subjectNumber: props.parameter.subjectNumber,
        defaultEmailAddress: props.parameter.defaultEmailAddress,
        OtherSubject: props.parameter.OtherSubject,
        Message: props.parameter.Message,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await contactusmail(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
